(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["saydian-brand-story-carousel-v2"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('saydian-story-carousel-v2')) {
    class SaydianStoryCarousel extends HTMLElement {
      connectedCallback() {
        if (this.carouselInitialized) return;

        this.slides = Array.from(this.querySelectorAll('[data-carousel-slide]'));
        if (this.slides.length < 2) return;

        this.carouselInitialized = true;
        this.dots = Array.from(this.querySelectorAll('[data-carousel-dot]'));
        this.autoplayEnabled = this.dataset.autoplay === 'true';
        this.interval = Math.max(3000, Number.parseInt(this.dataset.interval, 10) || 5000);
        this.currentIndex = 0;
        this.timer = null;
        this.reducedMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.motionPaused = this.reducedMotionQuery.matches;
        this.abortController = new AbortController();

        const listenerOptions = { signal: this.abortController.signal };

        this.dots.forEach((dot) => {
          dot.addEventListener('click', (event) => this.handleDotClick(event), listenerOptions);
        });

        document.addEventListener('visibilitychange', () => this.handleVisibilityChange(), listenerOptions);
        this.reducedMotionQuery.addEventListener('change', (event) => this.handleMotionChange(event), listenerOptions);

        this.showSlide(0);
        this.startAutoplay();
      }

      disconnectedCallback() {
        this.stopAutoplay();
        if (this.abortController) this.abortController.abort();
        this.carouselInitialized = false;
      }

      showSlide(nextIndex) {
        this.currentIndex = (nextIndex + this.slides.length) % this.slides.length;

        this.slides.forEach((slide, index) => {
          const isActive = index === this.currentIndex;
          slide.classList.toggle('is-active', isActive);
          slide.setAttribute('aria-hidden', isActive ? 'false' : 'true');
        });

        this.dots.forEach((dot, index) => {
          const isActive = index === this.currentIndex;
          dot.classList.toggle('is-active', isActive);
          dot.setAttribute('aria-current', isActive ? 'true' : 'false');
        });
      }

      stopAutoplay() {
        if (this.timer !== null) {
          window.clearInterval(this.timer);
          this.timer = null;
        }
      }

      canAutoplay() {
        return (
          this.autoplayEnabled &&
          !this.motionPaused &&
          !document.hidden
        );
      }

      startAutoplay() {
        this.stopAutoplay();
        if (!this.canAutoplay()) return;

        this.timer = window.setInterval(() => {
          this.showSlide(this.currentIndex + 1);
        }, this.interval);
      }

      handleDotClick(event) {
        this.showSlide(Number.parseInt(event.currentTarget.dataset.slideIndex, 10) || 0);
        this.startAutoplay();
      }

      handleVisibilityChange() {
        if (document.hidden) {
          this.stopAutoplay();
        } else {
          this.startAutoplay();
        }
      }

      handleMotionChange(event) {
        this.motionPaused = event.matches;
        this.startAutoplay();
      }

    }

    customElements.define('saydian-story-carousel-v2', SaydianStoryCarousel);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["saydian-brand-story-video-carousel-v3"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('saydian-story-video-carousel-v3')) {
    class SaydianStoryVideoCarousel extends HTMLElement {
      connectedCallback() {
        if (this.carouselInitialized) return;

        this.slides = Array.from(this.querySelectorAll('[data-carousel-slide]'));
        if (this.slides.length === 0) return;

        this.carouselInitialized = true;
        this.dots = Array.from(this.querySelectorAll('[data-carousel-dot]'));
        this.videos = this.slides.map((slide) => slide.querySelector('video'));
        this.autoplayEnabled = this.dataset.autoplay === 'true';
        this.fallbackInterval = Math.max(
          3000,
          Number.parseInt(this.dataset.fallbackInterval, 10) || 8000
        );
        this.currentIndex = 0;
        this.timer = null;
        this.consecutiveErrors = 0;
        this.reducedMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.motionPaused = this.reducedMotionQuery.matches;
        this.inViewport = true;
        this.abortController = new AbortController();

        const listenerOptions = { signal: this.abortController.signal };

        this.dots.forEach((dot) => {
          dot.addEventListener('click', (event) => this.handleDotClick(event), listenerOptions);
        });

        this.videos.forEach((video, index) => {
          if (!video) return;

          video.muted = true;
          video.defaultMuted = true;
          video.playsInline = true;
          video.addEventListener('ended', () => this.handleVideoEnded(index), listenerOptions);
          video.addEventListener('error', () => this.handleVideoError(index), listenerOptions);
          video.addEventListener(
            'loadedmetadata',
            () => {
              if (index === this.currentIndex && this.canAutoplay()) {
                this.scheduleWatchdog(video);
              }
            },
            listenerOptions
          );
        });

        document.addEventListener('visibilitychange', () => this.handleVisibilityChange(), listenerOptions);
        this.reducedMotionQuery.addEventListener('change', (event) => this.handleMotionChange(event), listenerOptions);

        this.updateNativeControls();

        if ('IntersectionObserver' in window) {
          this.inViewport = false;
          this.intersectionObserver = new IntersectionObserver(
            (entries) => this.handleIntersection(entries[0]),
            { threshold: 0.15 }
          );
          this.intersectionObserver.observe(this);
        }

        this.showSlide(0, true);
      }

      disconnectedCallback() {
        this.stopPlayback();
        if (this.intersectionObserver) this.intersectionObserver.disconnect();
        if (this.abortController) this.abortController.abort();
        this.carouselInitialized = false;
      }

      showSlide(nextIndex, restartVideo) {
        this.clearAdvanceTimer();
        this.currentIndex = (nextIndex + this.slides.length) % this.slides.length;

        this.slides.forEach((slide, index) => {
          const isActive = index === this.currentIndex;
          slide.classList.toggle('is-active', isActive);
          slide.setAttribute('aria-hidden', isActive ? 'false' : 'true');
        });

        this.dots.forEach((dot, index) => {
          const isActive = index === this.currentIndex;
          dot.classList.toggle('is-active', isActive);
          dot.setAttribute('aria-current', isActive ? 'true' : 'false');
        });

        this.videos.forEach((video, index) => {
          if (!video || index === this.currentIndex) return;
          video.pause();
          this.resetVideo(video);
        });

        if (restartVideo) this.resetVideo(this.videos[this.currentIndex]);
        this.playCurrentVideo();
      }

      handleDotClick(event) {
        this.showSlide(Number.parseInt(event.currentTarget.dataset.slideIndex, 10) || 0, true);
      }

      handleVideoEnded(index) {
        if (index !== this.currentIndex || !this.canAutoplay()) return;
        this.consecutiveErrors = 0;
        this.showSlide(this.currentIndex + 1, true);
      }

      handleVideoError(index) {
        if (index !== this.currentIndex || !this.canAutoplay()) return;
        this.consecutiveErrors += 1;
        if (this.consecutiveErrors >= this.slides.length) {
          this.stopPlayback();
          return;
        }
        this.scheduleWatchdog(null);
      }

      handleIntersection(entry) {
        this.inViewport = Boolean(entry && entry.isIntersecting);
        if (this.inViewport) {
          this.playCurrentVideo();
        } else {
          this.stopPlayback();
        }
      }

      handleVisibilityChange() {
        if (document.hidden) {
          this.stopPlayback();
        } else {
          this.playCurrentVideo();
        }
      }

      handleMotionChange(event) {
        this.motionPaused = event.matches;
        this.updateNativeControls();
        if (this.motionPaused) {
          this.stopPlayback();
        } else {
          this.playCurrentVideo();
        }
      }

      canAutoplay() {
        return this.autoplayEnabled && !this.motionPaused && !document.hidden && this.inViewport;
      }

      playCurrentVideo() {
        this.clearAdvanceTimer();
        if (!this.canAutoplay()) return;

        const video = this.videos[this.currentIndex];
        if (!video) {
          this.scheduleWatchdog(null);
          return;
        }

        video.muted = true;
        video.defaultMuted = true;
        const playPromise = video.play();
        this.scheduleWatchdog(video);
        this.prepareNextVideo();

        if (playPromise && typeof playPromise.catch === 'function') {
          playPromise
            .then(() => {
              this.consecutiveErrors = 0;
            })
            .catch(() => this.handlePlayFailure(video));
        }
      }

      handlePlayFailure(video) {
        if (video !== this.videos[this.currentIndex] || !this.canAutoplay()) return;
        this.consecutiveErrors += 1;
        if (this.consecutiveErrors >= this.slides.length) {
          this.stopPlayback();
          return;
        }
        this.scheduleWatchdog(null);
      }

      prepareNextVideo() {
        if (this.videos.length < 2) return;
        const nextVideo = this.videos[(this.currentIndex + 1) % this.videos.length];
        if (!nextVideo || nextVideo.preload !== 'none') return;
        nextVideo.preload = 'metadata';
        nextVideo.load();
      }

      updateNativeControls() {
        const showControls = !this.autoplayEnabled || this.motionPaused;
        this.videos.forEach((video) => {
          if (video) video.controls = showControls;
        });
      }

      scheduleWatchdog(video) {
        this.clearAdvanceTimer();

        let delay = this.fallbackInterval;
        if (video && Number.isFinite(video.duration) && video.duration > 0) {
          const remainingSeconds = Math.max(0, video.duration - video.currentTime);
          delay = Math.max(3000, Math.ceil((remainingSeconds + 1) * 1000));
        }

        this.timer = window.setTimeout(() => {
          if (this.canAutoplay()) this.showSlide(this.currentIndex + 1, true);
        }, delay);
      }

      clearAdvanceTimer() {
        if (this.timer === null) return;
        window.clearTimeout(this.timer);
        this.timer = null;
      }

      stopPlayback() {
        this.clearAdvanceTimer();
        this.videos.forEach((video) => {
          if (video) video.pause();
        });
      }

      resetVideo(video) {
        if (!video || video.readyState === 0) return;
        try {
          video.currentTime = 0;
        } catch (error) {
          // Some browsers block seeking until video metadata is ready.
        }
      }
    }

    customElements.define('saydian-story-video-carousel-v3', SaydianStoryVideoCarousel);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["saydian-brand-story"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('saydian-story-carousel')) {
    class SaydianStoryCarousel extends HTMLElement {
      connectedCallback() {
        if (this.carouselInitialized) return;

        this.slides = Array.from(this.querySelectorAll('[data-carousel-slide]'));
        if (this.slides.length < 2) return;

        this.carouselInitialized = true;
        this.dots = Array.from(this.querySelectorAll('[data-carousel-dot]'));
        this.toggleButton = this.querySelector('[data-carousel-toggle]');
        this.autoplayEnabled = this.dataset.autoplay === 'true';
        this.interval = Math.max(3000, Number.parseInt(this.dataset.interval, 10) || 5000);
        this.currentIndex = 0;
        this.timer = null;
        this.userPaused = false;
        this.hoverPaused = false;
        this.focusPaused = false;
        this.reducedMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.motionPaused = this.reducedMotionQuery.matches;
        this.abortController = new AbortController();

        const listenerOptions = { signal: this.abortController.signal };

        this.dots.forEach((dot) => {
          dot.addEventListener('click', (event) => this.handleDotClick(event), listenerOptions);
        });

        if (this.toggleButton) {
          this.toggleButton.addEventListener('click', () => this.handleToggleClick(), listenerOptions);
        }

        this.addEventListener('mouseenter', () => this.handleMouseEnter(), listenerOptions);
        this.addEventListener('mouseleave', () => this.handleMouseLeave(), listenerOptions);
        this.addEventListener('focusin', () => this.handleFocusIn(), listenerOptions);
        this.addEventListener('focusout', () => this.handleFocusOut(), listenerOptions);
        document.addEventListener('visibilitychange', () => this.handleVisibilityChange(), listenerOptions);
        this.reducedMotionQuery.addEventListener('change', (event) => this.handleMotionChange(event), listenerOptions);

        this.showSlide(0);
        this.updateToggle();
        this.startAutoplay();
      }

      disconnectedCallback() {
        this.stopAutoplay();
        if (this.abortController) this.abortController.abort();
        this.carouselInitialized = false;
      }

      showSlide(nextIndex) {
        this.currentIndex = (nextIndex + this.slides.length) % this.slides.length;

        this.slides.forEach((slide, index) => {
          const isActive = index === this.currentIndex;
          slide.classList.toggle('is-active', isActive);
          slide.setAttribute('aria-hidden', isActive ? 'false' : 'true');
        });

        this.dots.forEach((dot, index) => {
          const isActive = index === this.currentIndex;
          dot.classList.toggle('is-active', isActive);
          dot.setAttribute('aria-current', isActive ? 'true' : 'false');
        });
      }

      stopAutoplay() {
        if (this.timer !== null) {
          window.clearInterval(this.timer);
          this.timer = null;
        }
      }

      canAutoplay() {
        return (
          this.autoplayEnabled &&
          !this.userPaused &&
          !this.hoverPaused &&
          !this.focusPaused &&
          !this.motionPaused &&
          !document.hidden
        );
      }

      startAutoplay() {
        this.stopAutoplay();
        if (!this.canAutoplay()) return;

        this.timer = window.setInterval(() => {
          this.showSlide(this.currentIndex + 1);
        }, this.interval);
      }

      updateToggle() {
        if (!this.toggleButton) return;

        this.toggleButton.hidden = this.motionPaused;
        this.toggleButton.dataset.paused = this.userPaused ? 'true' : 'false';
        this.toggleButton.setAttribute('aria-pressed', this.userPaused ? 'true' : 'false');
        this.toggleButton.setAttribute(
          'aria-label',
          this.userPaused ? 'Start automatic slideshow' : 'Pause automatic slideshow'
        );
      }

      handleDotClick(event) {
        this.userPaused = true;
        this.stopAutoplay();
        this.showSlide(Number.parseInt(event.currentTarget.dataset.slideIndex, 10) || 0);
        this.updateToggle();
      }

      handleToggleClick() {
        this.userPaused = !this.userPaused;
        this.updateToggle();
        this.startAutoplay();
      }

      handleMouseEnter() {
        this.hoverPaused = true;
        this.stopAutoplay();
      }

      handleMouseLeave() {
        this.hoverPaused = false;
        this.startAutoplay();
      }

      handleFocusIn() {
        this.focusPaused = true;
        this.stopAutoplay();
      }

      handleFocusOut() {
        window.setTimeout(() => {
          if (!this.isConnected) return;
          this.focusPaused = this.contains(document.activeElement);
          this.startAutoplay();
        }, 0);
      }

      handleVisibilityChange() {
        if (document.hidden) {
          this.stopAutoplay();
        } else {
          this.startAutoplay();
        }
      }

      handleMotionChange(event) {
        this.motionPaused = event.matches;
        this.updateToggle();
        this.startAutoplay();
      }

    }

    customElements.define('saydian-story-carousel', SaydianStoryCarousel);
  }

  } catch(e) { console.error(e); }
})();
})();
